import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CommsService } from '../../services/comms/comms.service';
import { DataService } from '../../services/data/data.service';
import { NoteService } from '../../services/note/note.service';
import { UserService } from '../../services/user/user.service';
import { ConfigService } from '../../services/config/config.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DisplayService } from '../../services/display/display.service';
import { TabService } from '../tab/tab.service';
import { TimesheetService } from '../timesheet/timesheet.service';
import { DataTableService } from '../../services/dataTable/dataTable.service';
import _ from 'lodash';

@Injectable()
export class InvoiceService {

	objString = 'Invoice';
	objRoot = 'invoice';
	listRoot = 'invoices';
	dataObj = 'invoice';
	bcDataObj = 'bcinvoice';
	supDataObj = 'supplierinvoice';
	timesheetDataObj = 'timesheet-invoice';
	pendingDataObj = 'invoice-pending';
	failedDataObj = 'invoice-failed';
	errorDataObj = 'supplierinvoiceerror';
	successDataObj = 'supplierinvoicesuccess';
	scDataObj;

	dataConfig;
	supDataConfig;
	bcDataConfig;

	showErrorSupplierInvoices = false;
	showSuccessSupplierInvoices = false;

	activePO = '';

	failureReasons: Array<string>;

	tabsData = {
		listTabs: [
			{
				prop: 'pending',
				name: 'Pending',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'all',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'failed',
				name: 'Failed',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'inactive',
				name: 'Inactive',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		supListTabs: [
			{
				prop: 'pending',
				name: 'Pending',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'BDW',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'all',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'BDW',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'failed',
				name: 'Failed',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'BDW',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'inactive',
				name: 'Inactive',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'BDW',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		bcListTabs: [
			{
				prop: 'pending',
				name: 'Pending',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'BC',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'all',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'BC',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'failed',
				name: 'Failed',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'BC',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		poListTabs: [
			{
				prop: 'pending',
				name: 'Pending',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'po',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'all',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'po',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'failed',
				name: 'Failed',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'po',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		cancelledPOListTabs: [
			{
				prop: 'all',
				name: 'All',
				active: true,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'po',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		detailsListTabs: [
			{
				prop: 'all',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'details',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		detailsSupListTabs: [
			{
				prop: 'all',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'details-BDW',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		]
	};

	rowsPerSupplierPage: number;

	constructor(
		private router: Router,
		private commsService: CommsService,
		private dataService: DataService,
		private noteService: NoteService,
		private userService: UserService,
		private configService: ConfigService,
		private displayService: DisplayService,
		private tabService: TabService,
		private timesheetService: TimesheetService,
		private dataTableService: DataTableService
	) {
		this.scDataObj = this.configService.invoiceSCDataObj;
		this.rowsPerSupplierPage = this.configService.pageSize;
	}

	// TABBING METHODS

	getActiveTab(tabsData): any {
		let activeTab: any = {};
		tabsData.forEach(function (d, i) {
			if (d.active) {
				activeTab = d;
			}
		});
		return activeTab;
	}

	tabClick(event, tabProp, tabsData, type) {
		console.log('TAB CLICK', event, tabProp, tabsData);
		const self = this;
		tabsData.forEach(function (d, i) {
			d.active = false;
			d.page = 0;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				if (d.listTab) {
					switch (d.type) {
						case 'standard':
							window.history.replaceState({}, '', '/invoices/' + tabProp);
							self.loadInvoicesForTab(d);
							break;
						case 'BDW':
							window.history.replaceState({}, '', '/supplier-invoices/' + tabProp);
							self.loadInvoicesForTab(d);
							break;
						case 'BC':
							window.history.replaceState({}, '', '/blockchain-invoices/' + tabProp);
							self.loadInvoicesForTab(d);
							break;
						case 'details':
						case 'details-BDW':
							self.loadInvoicesForTab(d);
							break;
						case 'po':
							self.loadPOInvoicesForTab(d);
							break;
					}
				}
			}
		});
	}

	selectDefaultTab(tabsData) {
		const self = this;
		tabsData.forEach(function (d, i) {
			tabsData[i].active = false;
			tabsData[i].cached = false;
		});
		let foundDefault = false;
		let defaultIndex = -1;
		tabsData.forEach(function (d, i) {
			console.log('CHECK TAB FOR DEFAULT', d, self.tabService.showTab(d.persona, d.notPersona));
			if (self.tabService.showTab(d.persona, d.notPersona) && !foundDefault) {
				foundDefault = true;
				defaultIndex = i;
				if (d.listTab) {
					switch (d.type) {
						case 'standard':
						case 'BDW':
						case 'details':
						case 'details-BDW':
						case 'BC':
							self.loadInvoicesForTab(d);
							break;
						case 'po':
							self.loadPOInvoicesForTab(d);
							break;
					}
				}
			}
		});
		tabsData[defaultIndex].active = true;
		console.log('SELECTED DEFAULT TAB', tabsData);
	}

	selectActiveTab(tabsData, tabProp) {
		const self = this;
		tabsData.forEach(function (d, i) {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				if (d.listTab) {
					switch (d.type) {
						case 'standard':
						case 'BDW':
						case 'details':
						case 'details-BDW':
							self.loadInvoicesForTab(d);
							break;
						case 'po':
							self.loadPOInvoicesForTab(d);
							break;
					}
				}
			}
		});
	}

	showTabSearch(tabsData) {
		this.getActiveTab(tabsData)['searching'] = !this.getActiveTab(tabsData)['searching'];
	}

	checkTabs(tabsData) {
		// expected method, no logic needed for po page tabs
		// see same method in contractorService for example of use
	}

	loadInvoicesForTab(tab, loadAll = false) {
		console.log('LOAD INVOICES FOR TAB', tab);
		const self = this;
		if (tab['type'] === 'BDW') {
			this.loadSupplierInvoices(tab, loadAll);
		} else if (tab['type'] === 'details-BDW') {
			const dataRef = this.supDataObj + '-' + tab.prop + '-' + tab.type;
			let supInvoices = [];
			if (this.dataService.invoiceDetails['supplierinvoices']) {
				supInvoices = this.processInvoiceAmt(this.dataService.invoiceDetails['supplierinvoices']);
				// supInvoices = this.dataService.invoiceDetails['supplierinvoices'];
				// supInvoices.map(invoice => self.parseInvoice(invoice));
			}
			const bIdx = tab.page * this.configService.pageSize;
			const eIdx = (tab.page + 1) * this.configService.pageSize >= supInvoices.length ? supInvoices.length : (tab.page + 1) * this.configService.pageSize;
			this.dataService.updatePageData(dataRef, tab, supInvoices.slice(bIdx, eIdx));
			this.dataService.updateDataCount(dataRef, supInvoices.length);
		} else if (tab['type'] === 'details') {
			const dataRef = this.bcDataObj + '-' + tab.prop + '-' + tab.type;
			let bcInvoices = [];
			if (this.dataService.invoiceDetails['bcinvoices']) {
				bcInvoices = this.processInvoiceAmt(this.dataService.invoiceDetails['bcinvoices']);
				// bcInvoices = this.dataService.invoiceDetails['bcinvoices'];
				// bcInvoices.map(invoice => this.parseInvoice(invoice));
			}
			const bIdx = tab.page * this.configService.pageSize;
			const eIdx = (tab.page + 1) * this.configService.pageSize >= bcInvoices.length ? bcInvoices.length : (tab.page + 1) * this.configService.pageSize;
			this.dataService.updatePageData(dataRef, tab, bcInvoices.slice(bIdx, eIdx));
			this.dataService.updateDataCount(dataRef, bcInvoices.length);
		} else if (tab['type'] === 'BC') {
			this.loadBCInvoices(tab, loadAll);
		} else {
			this.loadInvoices(tab, loadAll);
		}
	}

	downloadInvoicesForTab(tab) {
		this.commsService.downloadAllInvoices(tab).subscribe((res) => {
			this.commsService.saveToCSV(tab.filename, res);
		}, (err) => {
			let msg = 'Download All Invoices';
			if (tab.type === 'BDW') {
				msg = 'Download All Supplier Invoices';
			}
			this.commsService.handleAPIError(msg, err);
		});
	}

	processInvoiceAmt(invoices) {
		invoices.forEach(invoice => {
			const amt = invoice['grossamount'];
			if (amt && !Number.isInteger(amt)) {
				invoice['grossamount'] = amt.toFixed(2);
			}
			invoice.items.forEach(item => {
				switch (item.type) {
					case 1:
					invoice['straighttime'] = item.grossamt;
					break;
					case 2:
					invoice['overtime'] = item.grossamt;
					break;
					case 3:
					invoice['expenses'] = item.grossamt;
					break;
					case 4:
					invoice['doubletime'] = item.grossamt;
					break;
				}
			});
		});
		return invoices;
	}

	loadPOInvoicesForTab(tab) {
		console.log('LOAD PO INVOICES FOR TAB', tab);
		this.loadPOInvoices(tab);
	}

	// UI INTERACTIONS

	closeInvoice() {
		this.dataService.clearInvoiceDetails();
	}

	tableClick(event) {
		console.log('INVOICE TABLE CLICK: ', event);
		const clickedRow = event.row;
		if (!clickedRow.ponumber || !clickedRow.supplierid || !clickedRow.billingstart || !clickedRow.billingend) {
			this.noteService.displayError('The selected invoice does not exists.');
		} else {
			this.router.navigateByUrl(this.objRoot + '/' + clickedRow.ponumber + '/' + clickedRow.supplierid
			+ '/' + clickedRow.billingstart + '/' + clickedRow.billingend );
		}
	}

	tableSelect(event) {
		console.log('INVOICE TABLE SELECT: ', event, this.dataService.selectedTableRows);
		this.dataService.selectedTableRows = event.selected;
	}

	tableRefresh(event) {
		console.log('INVOICE TABLE REFRESH: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.loadInvoicesForTab(activeTab);
	}

	tablePage(event) {
		console.log('INVOICE TABLE PAGE: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		activeTab['page'] = event.offset;
		this.loadInvoicesForTab(activeTab);
	}

	bcInvoicetablePage(event) {
		console.log('INVOICE TABLE PAGE: ', event);
		const activeTab = this.getActiveTab(this.tabsData.detailsListTabs);
		activeTab['page'] = event.offset;
		this.loadInvoicesForTab(activeTab);
	}

	supInvoicetablePage(event) {
		console.log('INVOICE TABLE PAGE: ', event);
		const activeTab = this.getActiveTab(this.tabsData.detailsSupListTabs);
		activeTab['page'] = event.offset;
		this.loadInvoicesForTab(activeTab);
	}

	tableSort(event) {
		this.dataTableService.tableSort(event, this.getActiveTab(this.tabsData.listTabs), (tab) => this.loadInvoicesForTab(tab));
	}

	tableSearch(event) {
		console.log('INVOICE TABLE SEARCH: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.loadInvoicesForTab(activeTab);
	}

	poTablePage(event, tabs?) {
		console.log('INVOICE PO TABLE PAGE: ', event);
		if (!tabs) {
			tabs = this.tabsData.poListTabs;
		}
		const activeTab = this.getActiveTab(tabs);
		this.getActiveTab(tabs)['page'] = event.offset;
		this.loadPOInvoicesForTab(activeTab);
	}

	// AUTOMATED PROCESSES


	removeZeroValues(invoice) {
		if (!invoice[this.configService.invoiceChaincodeProp]) {
			return invoice;
		}
		const clearedInvoice = _.cloneDeep(invoice);
		if (invoice[this.configService.invoiceChaincodeProp][this.configService.invoiceStraightTimeProp] === 0) {
			clearedInvoice[this.configService.invoiceChaincodeProp][this.configService.invoiceStraightTimeProp] = '';
		}

		if (invoice[this.configService.invoiceChaincodeProp][this.configService.invoiceOvertimeProp] === 0) {
			clearedInvoice[this.configService.invoiceChaincodeProp][this.configService.invoiceOvertimeProp] = '';
		}

		if (invoice[this.configService.invoiceChaincodeProp][this.configService.invoiceExpensesProp] === 0) {
			clearedInvoice[this.configService.invoiceChaincodeProp][this.configService.invoiceExpensesProp] = '';
		}
		if (invoice[this.configService.invoiceSupplierProp][this.configService.invoiceStraightTimeProp] === 0) {
			clearedInvoice[this.configService.invoiceSupplierProp][this.configService.invoiceStraightTimeProp] = '';
		}

		if (invoice[this.configService.invoiceSupplierProp][this.configService.invoiceOvertimeProp] === 0) {
			clearedInvoice[this.configService.invoiceSupplierProp][this.configService.invoiceOvertimeProp] = '';
		}

		if (invoice[this.configService.invoiceSupplierProp][this.configService.invoiceExpensesProp] === 0) {
			clearedInvoice[this.configService.invoiceSupplierProp][this.configService.invoiceExpensesProp] = '';
		}

		if (invoice[this.configService.invoiceChaincodeProp][this.configService.invoiceInvoiceAmtProp] === 0) {
			clearedInvoice[this.configService.invoiceChaincodeProp][this.configService.invoiceInvoiceAmtProp] = '';
		}

		if (invoice[this.configService.invoiceSupplierProp][this.configService.invoiceInvoiceAmtProp] === 0) {
			clearedInvoice[this.configService.invoiceSupplierProp][this.configService.invoiceInvoiceAmtProp] = '';
		}
		return clearedInvoice;
	}

	parseInvoice(data) {
		data = this.parseEmails(data);
		
		let parsedInvoice = _.cloneDeep(data);

		parsedInvoice = this.removeZeroValues(parsedInvoice);

		parsedInvoice[this.configService.invoiceStatusProp] = this.getInvoiceStatus(parsedInvoice);

		return parsedInvoice;

	}

	parseEmails(data) {
		data.pmemail = data.acl.pm.participants[0];
		data.samemail = data.acl.sam.participants[0];
		data.traemail = data.acl.tra.participants.length > 0 ? data.acl.tra.participants[0] : '';
		data.conemail = data.acl.contractor.participants[0];

		return data;
	}

	getInvoiceStatus(parsedInvoice) {
		let status = 'Pending';

		const supplierInvoiceNumber = parsedInvoice[this.configService.invoiceNumberProp];
		const supplierInvoiceKey = parsedInvoice[this.configService.invoiceSupplierProp][this.configService.invoiceKeyProp];

		const recStatus = parsedInvoice[this.configService.invoiceRecStatusProp];

		if (supplierInvoiceNumber === '' || supplierInvoiceNumber === undefined) {
			status = 'Pending Supplier Invoice Number';
		}

		if (supplierInvoiceNumber !== '' && supplierInvoiceNumber !== undefined) {
			status = 'Pending Supplier Invoice';
		}

		if (supplierInvoiceKey !== '' && supplierInvoiceKey !== undefined) {
			status = 'Pending Reconciliation';
		}

		if (recStatus !== 'Pending') {
			status = 'Reconciled';
		}
		return status;
	}

	submitInvoiceNumber() {
		const data = {
			invoicenumber: this.dataService.invoiceDetails[this.configService.invoiceNumberProp],
			ponumber: this.dataService.invoiceDetails[this.configService.poNumberProp],
			bcinvkey: this.dataService.invoiceDetails[this.configService.invoiceKeyProp],
			supplierid: this.dataService.invoiceDetails[this.configService.supplierIdProp]
		};
		console.log('SUBMIT INVOICE NUMBER', data);
		this.sendInvoiceNumber(data);
	}


	sendInvoiceNumber(data) {
		const self = this;

		this.commsService.attachInvoiceNumber(data).subscribe((res) => {
			const successData = self.commsService.getSuccessData(res);
			console.log('SEND INVOICE NO RES: ', res);

			self.dataService.broadcastInvoiceUpdate();
			self.closeInvoice();

		}, (err) => {
			self.commsService.handleAPIError('Send Invoice Number', err);
		});
	}

	archiveInvoices(data, archive, callSource) {
		const self = this;
		let statusMsg = 'to Inactive tab ';
		if (!archive) {
			statusMsg = 'back to active ';
		}
		this.displayService.startLoading();
		this.commsService.archiveInvoices(data, archive).subscribe((res) => {
			self.noteService.displaySuccess('The selected invoice(s) has been moved ' + statusMsg + 'successfully.');
			callSource.successCall();
			self.displayService.endLoading();
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Archive Invoices', err);
		});
	}

	loadInvoices(data, loadAll = false) {
		const self = this;
		if (!loadAll) {
			// this.displayService.startLoading();
			this.displayService.activateLoadingTab(data, this.tabsData.listTabs);
		}

		this.commsService.getInvoiceList(data, loadAll).subscribe((res) => {
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.listTabs);
			}
			console.log('LOAD INVOICES RES: ', res);
			const successData = self.commsService.getSuccessData(res);
			const count = self.commsService.getSuccessCount(res);
			// let formattedInvoices = successData;
			const invoices = [];
			if (Array.isArray(successData) && successData.length > 0) {
				successData.forEach(function (d, i) {
					const invoice = self.parseInvoice(d);
					invoices.push(invoice);
				});
			}
			const formattedInvoices = this.configService.getTableData(invoices, this.dataObj);

			if (!loadAll) {
				const dataRef = self.dataObj + '-' + data.prop + '-' + data.type;
				self.dataService.updatePageData(dataRef, data, formattedInvoices);
				self.dataService.updateDataCount(dataRef, count);
			} else {
				self.dataService.broadcastLoadAll(formattedInvoices);
			}
		}, (err) => {
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.listTabs);
			}
			self.commsService.handleAPIError('Load Invoices', err);
		});
	}

	loadSupplierInvoices(data, loadAll = false) {
		const self = this;
		if (!loadAll) {
			// this.displayService.startLoading();
			this.displayService.activateLoadingTab(data, this.tabsData.supListTabs);
		}

		this.commsService.getSupplierInvoiceList(data, loadAll).subscribe((res) => {
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.supListTabs);
			}
			console.log('LOAD SUPPLIER INVOICES RES: ', res);
			const successData = self.commsService.getSuccessData(res);
			const count = self.commsService.getSuccessCount(res);

			const supplierInvoices = [];
			if (Array.isArray(successData) && successData.length > 0) {
				successData.forEach(function (d, i) {
					const invoice = self.parseEmails(d);
					supplierInvoices.push(invoice);
				});
			}

			if (!loadAll) {
				const dataRef = self.supDataObj + '-' + data.prop + '-' + data.type;
				self.dataService.updatePageData(dataRef, data, supplierInvoices);
				self.dataService.updateDataCount(dataRef, count);
			} else {
				self.dataService.broadcastLoadAll(supplierInvoices);
			}
		}, (err) => {
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.supListTabs);
			}
			self.commsService.handleAPIError('Load Supplier Invoices', err);
		});
	}

	loadBCInvoices(data, loadAll = false) {
		const self = this;
		if (!loadAll) {
			// this.displayService.startLoading();
			this.displayService.activateLoadingTab(data, this.tabsData.bcListTabs);
		}
		this.commsService.getBCInvoiceList(data, loadAll).subscribe((res) => {
			console.log('LOAD SUPPLIER INVOICES RES: ', res);
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.bcListTabs);
			}
			const successData = this.processInvoiceAmt(self.commsService.getSuccessData(res));
			const count = self.commsService.getSuccessCount(res);
			if (!loadAll) {
				const dataRef = self.bcDataObj + '-' + data.prop + '-' + data.type;
				self.dataService.updatePageData(dataRef, data, successData);
				self.dataService.updateDataCount(dataRef, count);
			} else {
				self.dataService.broadcastLoadAll(successData);
			}
		}, (err) => {
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.bcListTabs);
			}
			self.commsService.handleAPIError('Load Blockchain Invoices', err);
			const dataRef = self.bcDataObj + '-' + data.prop + '-' + data.type;
			self.dataService.updatePageData(dataRef, data, []);
			self.dataService.updateDataCount(dataRef, 0);
		});
	}


	loadAllforTab(tab) {
		// use API /csv to download reconciliation and supplier invoices
		if (tab.type === 'BDW' || tab.type === 'standard' || tab.type === 'BC') {
			this.downloadInvoicesForTab(tab);
		} else {
			this.loadInvoicesForTab(tab, true);
		}
	}

	loadPOInvoices(data) {
		const self = this;

		// this.displayService.startLoading();
		this.displayService.activateLoadingTab(data, this.tabsData.poListTabs);
		this.commsService.getPOInvoiceList(data, this.activePO).subscribe((res) => {
			// self.displayService.endLoading();
			self.displayService.deactivateLoadingTab(data, this.tabsData.poListTabs);
			console.log('LOAD PO INVOICES RES: ', res);

			const successData = self.commsService.getSuccessData(res);
			const count = self.commsService.getSuccessCount(res);
			const invoices = [];
			if (Array.isArray(successData) && successData.length > 0) {
				successData.forEach(function (d, i) {
					const invoice = self.parseInvoice(d);
					invoices.push(invoice);
				});
			}
			const formattedInvoices = this.configService.getTableData(invoices, this.dataObj);

			const dataRef = self.dataObj + '-' + data.prop + '-' + data.type;
			self.dataService.updatePageData(dataRef, data, formattedInvoices);
			self.dataService.updateDataCount(dataRef, count);

		}, (err) => {
			// this.displayService.endLoading();
			self.displayService.deactivateLoadingTab(data, this.tabsData.poListTabs);
			self.commsService.handleAPIError('Load PO Invoices', err);
		});
	}

	submitInvoice(data) {
		const self = this;

		this.displayService.startLoading();
		this.commsService.sendInvoice(data).subscribe((res) => {
			self.displayService.endLoading();
			const successData = self.commsService.getSuccessData(res);
			console.log('SUBMIT INVOICE RES', res);

			self.noteService.displaySuccess('The invoice has been submitted successfully.');
			self.dataService.broadcastNotifications(self.dataObj);

		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Submit Invoice', err);
		});
	}

	submitSupInvoice(data) {

		this.displayService.startLoading();
		const self = this;
		this.commsService.sendSupInvoice(data).subscribe((res) => {
			self.displayService.endLoading();
			self.noteService.displaySuccess('The invoice has been submitted successfully.');

		}, (err) => {
			this.displayService.endLoading();
			self.commsService.handleAPIError('Submit Invoice', err);
		});
	}

	loadRejectReasons() {
		console.log('LOADING REJECT REASONS');
		if (this.dataService.rejectreasons.length !== 0) { // do nothing if reject reasons already loaded
			return;
		}
		this.displayService.startLoading();
		this.commsService.getRejectReasons().subscribe((res) => {
			console.log('LOAD ACCEPTABLE REJECT REASONS: ', res);
			const successData = this.commsService.getSuccessData(res);
			this.dataService.updateRejectReasons(successData);
			this.displayService.endLoading();
		}, (err) => {
			this.displayService.endLoading();
			this.commsService.handleAPIError('Load Reject Reasons', err);
		});
	}


	disableEditCal() {
		let disableEdit = true;
		if (this.userService.persona.toLowerCase() === this.configService.personaProps['sam']) {
			disableEdit = false;
		}
		return disableEdit;
	}


	handlePartialSuccess(res) {
		console.log('HANDLE PARTIAL SUCCESS: ', res);
		this.showErrorSupplierInvoices = true;
		this.showSuccessSupplierInvoices = false;
		
		this.configService.resetTempTab();
		const tempTab = this.configService.tempTab;

		const errorRes = this.commsService.getPartialError(res);
		const errorCount = this.commsService.getSuccessCount(errorRes);
		const errorDataRef = this.errorDataObj + '-' + tempTab.prop + '-' + tempTab.type;
		this.dataService.updatePageData(errorDataRef, tempTab, errorRes);
		this.dataService.updateDataCount(errorDataRef, errorCount);

		const successRes = this.commsService.getPartialSuccess(res);
		const successCount = this.commsService.getSuccessCount(successRes);
		const successDataRef = this.successDataObj + '-' + tempTab.prop + '-' + tempTab.type;
		this.dataService.updatePageData(successDataRef, tempTab, successRes);
		this.dataService.updateDataCount(successDataRef, successCount);

		if (this.dataService.pageData[successDataRef][0].length > 0) {
			this.showSuccessSupplierInvoices = true;
		}
		console.log('PARTIAL SUCCESS SUPPLIER INVOICES', this.dataService.pageData[errorDataRef][0], this.dataService.pageData[successDataRef][0]);
	}

	closePartialSuccessModal(event) {
		this.showErrorSupplierInvoices = false;
		this.showSuccessSupplierInvoices = false;
	}

	parseItems(items, countryCode='default') {
		if (items !== null) {
			// mapping hour type in number (backend retrived from PO line number) to text (from country.json)
			const hourTypes = this.configService.getCountryConfig('invoiceHourTypes', countryCode);
			items.forEach(item => {
				const typeIdx = item[this.configService.invoiceTypeProp];
				if (typeIdx >= 1 && typeIdx <= hourTypes.length) {
					item[this.configService.invoiceTypeProp] = hourTypes[typeIdx - 1];
				}
			});
		}
		return items;
	}
}
